export enum BorderRadiusSize {
  NONE = 'none',
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
}

export enum Variant {
  INLINE = 'inline',
  BLOCK = 'block',
}

export interface BlockingComponentProps {
  /**
   * Property used for testing purposes
   */
  dataCy?: string;
  /**
   * Border Radius size. This can be one of the following options: `<component>.BorderRadiusSize.NONE`, `<component>.BorderRadiusSize.SMALL`,
   * `<component>.BorderRadiusSize.MEDIUM`, `<component>.BorderRadiusSize.BIG`
   */
  borderRadiusSize?: BorderRadiusSize;
  /**
   * Indicates if the blocking area is active
   */
  isActive?: boolean;
  /**
   * Variant of the blocking area
   */
  variant?: Variant;
  /**
   * Function that is executed when the BlockingArea is clicked on
   */
  onClick?: () => void;
}
